import React from 'react'
// Styles
import * as styles from './style'
// Helpers
import { internalLinkHandler, internalUrl } from '../../../utils/link.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'
// Components
import Marketo from '../../global/marketo'
import Button from '../button'
import Typography from '../typography'

const MainCTA = (props: any) => {
  if (props.data) {
    let title: string = '',
      subtitle: string = '',
      cta: { externalUrl: string; text: string; internalLink?: internalUrl }[] | undefined,
      disclaimer: string = ''

    if (props.data.title) title = props.data.title
    if (props.data.subtitle) subtitle = props.data.subtitle
    if (props.data.ctAs) cta = props.data.ctAs
    if (props.data.disclaimer) disclaimer = props.data.disclaimer

    const isForm = props.data.marketoForm && props.data.marketoForm.marketoForm ? true : false

    return (
      <styles.MainCTA $isForm={isForm} data-cy="MainCTA">
        <div className="MainCTA__Inner">
          <Typography className="MainCTA__Title" type="header2">
            {formatInlineCode(title)}
          </Typography>
          {subtitle && (
            <Typography className="MainCTA__Subtitle" type="leadXS">
              {formatInlineCode(subtitle)}
            </Typography>
          )}
          {isForm && (
            <Marketo data-cy="MainCTA-MKO-Form" formData={props.data.marketoForm.marketoForm} />
          )}
          <div className="MainCTA__Buttons">
            {cta && cta[0] && (cta[0].externalUrl || cta[0].internalLink) && cta[0].text && (
              <Button
                icon={true}
                href={
                  cta[0].internalLink
                    ? internalLinkHandler(cta[0].internalLink)
                    : cta[0].externalUrl
                }
                text={cta[0].text}
                type="primary"
                size="small"
                theme="light"
                data-cy="MainCTA-Button-One"
              />
            )}
            {cta && cta[1] && (cta[1].externalUrl || cta[1].internalLink) && cta[1].text && (
              <Button
                icon={true}
                href={
                  cta[1].internalLink
                    ? internalLinkHandler(cta[1].internalLink)
                    : cta[1].externalUrl
                }
                text={cta[1].text}
                type="tertiary"
                size="small"
                theme="light"
                data-cy="MainCTA-Button-Two"
              />
            )}
          </div>
          {disclaimer && <p className="MainCTA__Disclaimer">{formatInlineCode(disclaimer)}</p>}
        </div>
      </styles.MainCTA>
    )
  }

  return null
}

export default MainCTA
